<template>
  <div id="app">
    <v-app id="inspire">
      <altaciklama></altaciklama>
      <yetkidialog ref="yetkidialog"></yetkidialog>
      <v-content>
        <v-layout v-if="islemguncelle" row wrap>
          <v-flex xs12 sm12 md12>
            <v-tabs style="width:100%;" dark="" grow v-model="active" slider-color="white" color="blue darken-3"
              slot="extension" slider->
              <v-tab>
                {{ $t('tab_general') }}
              </v-tab>
              <v-tab-item>
                <v-card color="grey lighten-5" flat>
                  <v-layout row wrap>
                    <v-flex pt-2 pl-2 xs12 sm3 md3>
                      <v-card flat>
                        <v-layout row wrap class=" project overdue">
                          <v-flex xs12 pa-2 sm12 md12>
                            <v-text-field hide-details="" v-model="WebGrup.GroupName" :label="$t('Group-Name')"></v-text-field>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-flex>
                    <v-flex  v-if="sayfaguncellelist.length>0" xs12 sm9 md9>
                      <v-card class="white--text">
                        <v-card color="grey lighten-5" flat="">
                          <v-card-actions>
                            <v-layout row wrap>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-card flat>
                                    <v-layout row wrap class=" project overdue">
                                      <v-flex xs12 sm8 pt-2 md8>
                                        <v-toolbar flat="" size="120px" dark color="white">
                                          <v-toolbar-title> 
                                            <span class="title black--text">
                                              {{$t('Page-Authorization')}} 
                                            </span> 
                                          </v-toolbar-title>
                                          <v-spacer></v-spacer>
                                        </v-toolbar>
                                      </v-flex>
                                    </v-layout>
                                  </v-card>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                  <v-layout justify-end>
                                    <v-divider></v-divider>
                                  </v-layout>
                                </v-flex>

                                <v-layout row wrap>
                                  <v-flex xs12 sm12 md12>
                                    <v-list two line>
                                      <template>
                                        <v-layout row wrap>
                                          <v-flex xs12 sm4 md4>
                                            <v-layout column="" align-start>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm4 md2>
                                            <v-layout column="" align-start>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout justify-center column align-center>
                                                            {{ $t('Viewing') }}
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm4 md2>
                                            <v-layout column="" align-start>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            {{ $t('Saving') }}
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>



                                          <v-flex xs12 sm4 md2>
                                            <v-layout justify-start="" align-center>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout justify-center="" align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            {{ $t('Updating') }}
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>


                                          <v-flex xs12 sm4 md2>
                                            <v-layout justify-start="" align-center>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout justify-center="" align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column justify-center="" align-center>
                                                            {{ $t('Deleting') }}
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                        </v-layout>
                                        <v-divider></v-divider>
                                      </template>
                                      <template>
                                        <v-layout row wrap>
                                          <v-flex xs12 sm4 md4>
                                            <v-layout column="" align-start>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            {{ $t('Page-Name') }}
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm4 md2>
                                            <v-layout column="" align-start>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            <v-checkbox v-model="ekrancheck"></v-checkbox>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm4 md2>
                                            <v-layout column="" align-start>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            <v-checkbox v-model="kayitcheck"></v-checkbox>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>



                                          <v-flex xs12 sm4 md2>
                                            <v-layout justify-start="" align-center>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout justify-center="" align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            <v-checkbox v-model="guncellecheck"></v-checkbox>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>


                                          <v-flex xs12 sm4 md2>
                                            <v-layout justify-start="" align-center>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout justify-center="" align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column justify-center="" align-center>
                                                            <v-checkbox v-model="silcheck"></v-checkbox>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                        </v-layout>
                                        <v-divider></v-divider>
                                      </template>

                                      <template v-for="item in sayfaguncellelist">
                                        <v-layout row wrap v-bind:key="item.PageID">
                                          <v-flex xs12 sm1 md4>
                                            <v-layout column="" align-start>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            {{item.PageTitle}}
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>

                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm1 md2>
                                            <v-layout column="" align-start>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            <v-checkbox v-bind:checked="item.Screen"
                                                              v-model="dinamikmodelekran[item.PageName]"
                                                              :name="'ekran'+item.PageName" :id="'ekran'+item.PageName">
                                                            </v-checkbox>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                          <v-flex xs12 sm2 md2>
                                            <v-layout column="" align-start>
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            <v-checkbox :checked="item.Save"
                                                              v-model="dinamikmodelkaydet[item.PageName]"
                                                              :name="'kaydet'+item.PageName"
                                                              :id="'kaydet'+item.PageName"></v-checkbox>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>


                                          <v-flex xs12 sm1 md2>
                                            <v-layout align-center justify-start="" row fill-height="">
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            <v-checkbox v-model="dinamikmodelguncelle[item.PageName]"
                                                              :name="'guncelle'+item.PageName"
                                                              :id="'guncelle'+item.PageName"></v-checkbox>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>


                                          <v-flex xs12 sm1 md2>
                                            <v-layout justify-start="" align-center row fill-height="">
                                              <v-card flat="">
                                                <v-list-tile>
                                                  <v-list-tile-content>
                                                    <v-layout align-center>
                                                      <v-flex>
                                                        <v-list-tile-sub-title>
                                                          <v-layout column align-center>
                                                            <v-checkbox :checked="item.Delete"
                                                              v-model="dinamikmodelsil[item.PageName]"
                                                              :name="'sil'+item.PageName" :id="'sil'+item.PageName">
                                                            </v-checkbox>
                                                          </v-layout>
                                                        </v-list-tile-sub-title>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-list-tile-content>
                                                </v-list-tile>
                                              </v-card>
                                            </v-layout>
                                          </v-flex>

                                        </v-layout>
                                        <v-divider :key="item.id"></v-divider>
                                      </template>

                                    </v-list>
                                  </v-flex>
                                </v-layout>
                              </v-layout>

                            </v-layout>
                          </v-card-actions>
                        </v-card>
                      </v-card>
                    </v-flex>
                  </v-layout>
                </v-card>
              </v-tab-item>
              <v-tab ripple>
                {{$t('Group-User-List')}}
              </v-tab>
              <v-tab-item>
                <v-layout row wrap>
                  <v-flex pa-1 xs6 sm12 md12>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>
                          <v-flex xs12 sm12 md4>
                            <v-select hide-details label="Şirket Seçiniz" item-value="SirketKodu" :items="altsirketler"
                              item-text="SirketUnvani" v-model="altsirket"></v-select>
                          </v-flex>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>

                  <v-flex pa-1 xs12 sm6 md6>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>

                          <v-layout justify-space-between column>
                            <v-flex xs12 sm12 md12>
                              <v-toolbar flat="" size="120px" dark color="#9E9E9E">
                                <v-toolbar-title> {{$t('Unauthorized-Users')}} </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchyetkisiz"
                                  :label="$t('Search')" append-icon="search"></v-text-field>
                              </v-toolbar>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-card>
                                <v-data-table :headers="headersyetkisiz" v-model="selectedyetkisiz"
                                  :rows-per-page-items=[50,100] :items="itemsyetkisiz" :search="searchyetkisiz">
                                  <v-progress-linear slot="progress" indeterminate></v-progress-linear>
                                  <template slot="items" slot-scope="props">
                                    <tr item>
                                      <td class="text-xs-left">{{ props.item.AdSoyad }}</td>
                                      <td class="text-xs-left">{{ props.item.Email }}</td>
                                      <v-icon color="info" @click="kullaniciekle(props.item)">
                                        add_box
                                      </v-icon>
                                    </tr>
                                  </template>
                                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                     {{ $t('No-records-searched-for', { value: searchyetkisiz}) }}
                                  </v-alert>
                                </v-data-table>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>


                  <v-flex pa-1 xs12 sm6 md6>
                    <v-card class="white--text">
                      <v-card color="grey lighten-5" flat="">
                        <v-card-actions>

                          <v-layout justify-space-between column>
                            <v-flex xs12 sm12 md12>

                              <v-toolbar flat="" size="120px" dark color="#9E9E9E">

                                <v-toolbar-title> {{$t('Authorized-Users')}} </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-text-field flat="" solo-inverted="" hide-details v-model="searchyetkili" :label="$t('Search')"
                                  append-icon="search"></v-text-field>
                              </v-toolbar>
                            </v-flex>

                            <v-flex xs12 sm12 md12>

                              <v-card>

                                <v-data-table :headers="headersyetkili" :rows-per-page-items=[50,100]
                                  :items="itemsyetkili" :search="searchyetkili">
                                  <v-progress-linear slot="progress" indeterminate></v-progress-linear>

                                  <template slot="items" slot-scope="props">
                                    <tr item>
                                      <td class="text-xs-left">{{ props.item.AdSoyad }}</td>
                                      <td class="text-xs-left">{{ props.item.Email }}</td>
                                      <v-icon color="red" @click="kullanicisil(props.item)">
                                        delete </v-icon>
                                    </tr>
                                  </template>
                                  <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                    {{ $t('No-records-searched-for', { value: searchyetkili}) }}
                                  </v-alert>
                                </v-data-table>
                              </v-card>
                            </v-flex>
                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>




                </v-layout>
              </v-tab-item>
            </v-tabs>
          </v-flex>

        </v-layout>



        <v-layout v-if="islemyeni" row wrap>

          <v-flex pa-1 xs12 sm3 md4>
            <v-card class="white--text">
              <v-card color="grey lighten-5" flat="">
                <v-card-actions>

                  <v-layout justify-space-between column>
                    <v-flex xs12 sm12 md12>

                      <v-toolbar flat="" size="120px" dark color="#9E9E9E">

                        <v-toolbar-title> Grup Bilgileri </v-toolbar-title>
                        <v-spacer></v-spacer>
                      </v-toolbar>
                    </v-flex>

                    <v-select hide-details :label="$t('Select-Your-Main-Company')" item-value="MusteriKod" persistent-hint
                      :items="AnaSirketler" item-text="MusteriUnvan" v-model="AnaSirket" bottom></v-select>
                    <v-text-field hide-details="" v-model="WebGrup.GroupName" :label="$t('Group-Name')"></v-text-field>
                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>

          </v-flex>


          <v-flex pa-1 xs12 sm9 md8>
            <v-card class="white--text">
              <v-card color="grey lighten-5" flat="">
                <v-card-actions>
                  <v-layout row wrap>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>

                        <v-toolbar flat="" size="120px" dark color="#9E9E9E">

                          <v-toolbar-title>{{$t('Page-Authorization')}}</v-toolbar-title>
                          <v-spacer></v-spacer>

                        </v-toolbar>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-layout justify-end>
                          <v-divider></v-divider>
                        </v-layout>
                      </v-flex>



                      <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                          <v-list>

                            <template>
                              <v-layout row wrap>
                                <v-flex xs12 sm4 md4>
                                  <v-layout column="" align-start>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm4 md2>
                                  <v-layout column="" align-start>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout justify-center column align-center>
                                                  {{ $t('Viewing') }}
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm4 md2>
                                  <v-layout column="" align-start>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>
                                                {{ $t('Saving') }}
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>



                                <v-flex xs12 sm4 md2>
                                  <v-layout justify-start="" align-center>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout justify-center="" align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>
                                                  {{ $t('Updating') }}
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm4 md2>
                                  <v-layout justify-start="" align-center>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout justify-center="" align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column justify-center="" align-center>
                                                  {{ $t('Deleting') }}
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                              <v-divider></v-divider>
                            </template>
                            <template>
                              <v-layout row wrap>
                                <v-flex xs12 sm4 md4>
                                  <v-layout column="" align-start>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>
                                                  {{ $t('Page-Name') }}
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm4 md2>
                                  <v-layout column="" align-start>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>

                                                  <v-checkbox v-model="yeniekrancheck"></v-checkbox>
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm4 md2>
                                  <v-layout column="" align-start>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>
                                                  <v-checkbox v-model="yenikayitcheck"></v-checkbox>
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>



                                <v-flex xs12 sm4 md2>
                                  <v-layout justify-start="" align-center>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout justify-center="" align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>
                                                  <v-checkbox v-model="yeniguncellecheck"></v-checkbox>
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm4 md2>
                                  <v-layout justify-start="" align-center>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout justify-center="" align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column justify-center="" align-center>
                                                  <v-checkbox v-model="yenisilcheck"></v-checkbox>
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                              <v-divider></v-divider>
                            </template>

                            <template v-for="item in sayfalist">
                              <v-layout row wrap v-bind:key="item.PageID">
                                <v-flex xs12 sm1 md4>
                                  <v-layout column="" align-start>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>
                                                  {{item.PageTitle}}</v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>

                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm1 md2>
                                  <v-layout column="" align-start>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>
                                                  <v-checkbox :checked="item.Screen"
                                                    v-model="dinamikmodelekran[item.PageName]"
                                                    :name="'ekran'+item.PageName" :id="'ekran'+item.PageName">
                                                  </v-checkbox>
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>

                                <v-flex xs12 sm2 md2>
                                  <v-layout column="" align-start>
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>
                                                  <v-checkbox :checked="item.Save"
                                                    v-model="dinamikmodelkaydet[item.PageName]"
                                                    :name="'kaydet'+item.PageName" :id="'kaydet'+item.PageName">
                                                  </v-checkbox>
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm1 md2>
                                  <v-layout align-center justify-start="" row fill-height="">
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>
                                                  <v-checkbox v-model="dinamikmodelguncelle[item.PageName]"
                                                    :name="'guncelle'+item.PageName" :id="'guncelle'+item.PageName">
                                                  </v-checkbox>
                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>


                                <v-flex xs12 sm1 md2>
                                  <v-layout justify-start="" align-center row fill-height="">
                                    <v-card flat="">
                                      <v-list-tile>
                                        <v-list-tile-content>
                                          <v-layout align-center>
                                            <v-flex>
                                              <v-list-tile-sub-title>
                                                <v-layout column align-center>

                                                  <v-checkbox :checked="item.Delete"
                                                    v-model="dinamikmodelsil[item.PageName]" :name="'sil'+item.PageName"
                                                    :id="'sil'+item.PageName">
                                                  </v-checkbox>


                                                </v-layout>
                                              </v-list-tile-sub-title>
                                            </v-flex>
                                          </v-layout>
                                        </v-list-tile-content>
                                      </v-list-tile>
                                    </v-card>
                                  </v-layout>
                                </v-flex>

                              </v-layout>
                              <v-divider :key="item.id"></v-divider>
                            </template>


                          </v-list>
                        </v-flex>
                      </v-layout>
                    </v-layout>

                  </v-layout>
                </v-card-actions>
              </v-card>
            </v-card>
          </v-flex>







        </v-layout>

      </v-content>



      <navi v-model="drawer"></navi>



      <v-toolbar color="info" dark app :clipped-left="$vuetify.breakpoint.mdAndUp" fixed>
        <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>

        <v-toolbar-title style="width: 300px" class="ml-0 pl-3">
          <span class="hidden-sm-and-down">{{$t('Add-Authority-Group')}}</span>
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn v-if="islemyeni" @click="yenikullanicikaydet()" flat> <span class="hidden-sm-and-down"> {{ $t('save_button') }} </span>
        </v-btn>
        <v-btn v-if="islemguncelle" @click="sayfayetkiguncelle()" flat> <span class="hidden-sm-and-down"> {{ $t('Update') }}
          </span>
        </v-btn>


        <v-menu offset-x>
          <v-btn slot="activator" dark icon>
            <v-icon>more_vert</v-icon>
          </v-btn>

          <v-list>
            <a target="_self" v-bind:href="'#/uye/index/'">
              <v-list-tile>
                <v-list-tile-title> {{ $t('cancel_button') }}</v-list-tile-title>
              </v-list-tile>
            </a>
          </v-list>
        </v-menu>


      </v-toolbar>


      <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
        :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
        {{ text1 }}
        <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
      </v-snackbar>

    </v-app>
  </div>

</template>

<script>
  import auth from '../../../../api/auth'
  import navi from "@/components/app/account/navigator.vue"
  import altaciklama from "@/components/app/account/altaciklama.vue"
  import _ from 'underscore'
  import router from '../../../../router'
  import helpers from "@/components/app/customcomp/helpers.js"
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"
  import bolumcomp from "@/components/app/bilet/partpage/bolumcomp.vue"
  import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"

  export default {
     data() {
        return {
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      sondeger: 'Cari',
      yeniekrancheck: false,
      yenikayitcheck: false,
      yeniguncellecheck: false,
      yenisilcheck: false,

      ekrancheck: false,
      kayitcheck: false,
      guncellecheck: false,
      silcheck: false,

      sayfalist: [],
      sayfaguncellelist: [],
      yedeksayfaguncellelist: [],
      islemyeni: true,
      islemguncelle: false,
      dinamikmodelekran: [],
      dinamikmodelkaydet: [],
      dinamikmodelguncelle: [],
      dinamikmodelsil: [],
      altsirketler: [],
      altsirket: null,
      WebGrup: {
        GroupID: null,
        GroupName: null,
        CustomerID: null,
        CustomerCode: null,
        CustomerName: null,
        PagesInfo: [],
      },
      headersyetkili: [{
          text: this.$t('Name_Surname_label'),
          value: 'AdSoyad'
        },
        {
          text: this.$t('Email_label'),
          value: 'Email'
        }
      ],
      headersyetkisiz: [{
          text:  this.$t('Name_Surname_label'),
          value: 'AdSoyad'
        },
        {
          text: this.$t('Email_label'),
          value: 'Email',
          value: 'name'

        }
      ],
      itemsyetkili: [],
      itemsyetkisiz: [],
      searchyetkili: null,
      searchyetkisiz: null,
      AnaSirketKodu: null,
      selectedyetkisiz: [],
      selectedyetkili: [],
      sirketitems: [],
      detay: false,
      listeleme: true,
      active: null,
      UserInfo: {
        AdSoyad: null,
        Deleted: null,
        Email: null,
        GSM: null,
        KullaniciAdi: null,
        Sifre: null,
        UserID: null
      },
      yetkilist: [],
      listegorunum: true,
      islem: false,
      ManageInfo: {
        UserInfo: {
          UserID: null,
          AdSoyad: null,
          KullaniciAdi: null,
          Email: null,
          GSM: null,
          Sifre: null,
          Deleted: false,
        },
        AnaSirketInfo: []
      },

      WebUserAnaSirket: {
        MusteriID: null,
        MusteriKod: null,
        MusteriUnvan: null,
        UserTip: 0,
        Aktif: false
        // Masraf: null,
        // Referans: null,
        // Bolum: null,
      },

      kaydetbtn: false,
      guncellebtn: false,
      eklebtn: true,
      itemseklenen: [],
      yedekresponse: [],
      bekle: false,
      AnaSirketlerWiev: [],
      AnaSirketler: [],
      Sirketler: [],
      AnaSirket: {},
      Sirket: {},
      giris: true,
      Urunler: false,
      urunlerlist: [],
      active: false,
      sektor: '0',
      uyeliktipi: '0',
      productshow: [],
      odemetipi: false,
      havale: true,
      kredikarti: false,
      odemeekrani: false,
      toplamtutar: 0,
      urunekrani: true,
      musteriid: null,
      dialogyenisirket: false,
      yenisirketunvani: null,
      sirkettipi: '0',
      sayfatipi: 'Cari',
      itemssayfatip: [{
          value: 'Hepsi',
          text: this.$t('All-Groups'),
        },
        {
          value: 'Cari',
          text: this.$t('Current-Account'),
        },
        {
          value: 'Bilet',
          text: this.$t('Ticket'),
        },
        {
          value: 'Coper',
          text: 'Coper',
        },
        {
          value: 'Muhasebe',
          text: this.$t('Accounting'),
        },
        {
          value: 'Multi',
          text: this.$t('Other'),
        },
      ],
      karttipi: [{
          id: 'M',
          text: 'Master Card'
        },
        {
          id: 'VI',
          text: 'VISA'
        },
        {
          id: 'A',
          text: 'American Express'
        },
      ],
      sonkullanimAy: [{
          id: '01',
          text: '1'
        },
        {
          id: '02',
          text: '2'
        },
        {
          id: '03',
          text: '3'
        },
        {
          id: '04',
          text: '4'
        },
        {
          id: '05',
          text: '5'
        },
        {
          id: '06',
          text: '6'
        },
        {
          id: '07',
          text: '7'
        },
        {
          id: '08',
          text: '8'
        },
        {
          id: '09',
          text: '9'
        },
        {
          id: '10',
          text: '10'
        },
        {
          id: '11',
          text: '11'
        },
        {
          id: '12',
          text: '12'
        }
      ],
      sonkullanimYil: [
        '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015',
        '2016', '2017',
        '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028',
        '2029', '2030'
      ],
      dictionary: {
        custom: {
          kartno: {
            required: () => this.$t('This-space-cannot-left-blank'),
            min: this.$t('Card-Number-Must-16-Digits')
          },

          selectkarttipi: {
            required: () => this.$t('Please-choose'),
          },
          kartcari: {
            required: () => this.$t('Please-choose'),
          },
          selectsonkullanim: {
            required: () => this.$t('Please-choose'),
          },
          selectsonkullanimyil: {
            required: () => this.$t('Please-choose'),
          },

        }
      },

      itemsnavi: [{
          icon: 'business',
          text: this.$t('Corporate-transactions'),
          to: 'anasirket',
        },
        {
          icon: 'people',
          text: this.$t('Member-Transactions'),
          to: 'login-uye'
        },

      ],
      clipped: true,
      drawer: true,
      fixed: false,
      miniVariant: false,
      right: true,
      rightDrawer: false,
      UrunKayit: {
        ID: null,
        MusteriInfo: {
          MusteriID: null,
          MusteriKod: null
        },
        UrunInfo: {
          UrunID: null
        },
        UrunAdet: 1,
        BaslangicTarih: null,
        BitisTarih: null,
        Kontor: null,
        KalanKontor: null,
        SatisTarihi: null,
        SatisTutar: 0,
        Aktif: null,
        OdemeOnay: 'false'
      },

      mevcutsirketmi: true,
      yenisirket: false,
      dialog: false,
      items: [{
          icon: 'domain',
          text: this.$t('Corporate-transactions')
        },
        {
          icon: 'contacts',
          text: this.$t('Member-Transactions')
        },
      ],

      faturainfo: [],
      newuserstatus: false,
      loginstatus: true,
      drawer: null,
      e1: 0,
      e2: true,
      e3: true,
      e4: true,
      text1: '',
      snackbar: false,
      y: 'top',
      x: 'right',
      mode: '',
      timeout: 6000,
      rules: {
        required: (value) => !!value || this.$t('Mandatory-Areas'),
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || this.$t('Wrong-e-mail')
        }
      },
      YeniKullanici: {
        UserID: null,
        MusteriID: 0,
        KullaniciAdi: null,
        Email: null,
        Sifre: null,
        Tip: 0,
        AdSoyad: null,
        Deleted: false,
        Aktif: false,
        MusteriBilgi: [],
        OdemeOnay: false,
      },
      unvan: null,
      confirm: null,
      Credential: {
        email: '',
        password: ''
      },
      valid: true,
      errorMsg: '',
      errorAlert: false,
      }
    },
    props: {
      source: String
    },
    methods: {
      filtrele(b) {
        this.sayfaguncellelist = []
        var liste = this.yedeksayfaguncellelist
        if (this.sayfatipi != 'Hepsi') {
          var a = this.sayfatipi

          var filteritems = liste.filter(function (elmn) {
            if (elmn.PageGroup == a) {
              return true;
            }
          });
          this.sayfaguncellelist = filteritems
        } else {}
        this.sondeger = a
      },
      manageloadguncelle() {
        var response1 = JSON.parse(window.localStorage.getItem('response'));
        var userparams = {
          Email: response1.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          window.localStorage.setItem('WebUserManageLoad', JSON.stringify(response.body))
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-WebUserManageLoad'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-WebUserManageLoad'
            this.snackbar = true
          }
        })
      },
      kullaniciekle(val) {
        var input = []
        var kayit = {
          ID: null, //kullanici id
          UserID: val.UserID,
          GroupID: this.WebGrup.GroupID, // group id
          GroupName: null,
          CustomerID: this.AnaSirketKodu, // anaşirket
          CustomerCode: null,
          CustomerName: null,
          CompanyNo: this.altsirket // company
        }

        input.push(kayit)

        var params = input

        this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageUserAuthSave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          if (response.body.Status == true) {
            var params = {
              ID: null,
              UserID: null,
              CustomerID: this.AnaSirketKodu,
              CompanyNo: this.altsirket,
              GroupID: this.WebGrup.GroupID
            }

            this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageUserCompanyAuthList', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              this.itemsyetkili = response.body.AuthUserList
              this.itemsyetkisiz = response.body.NoAuthUserList

            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebPageUserCompanyAuthList'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable-WebPageUserCompanyAuthList'
                this.snackbar = true
              }
            })
          }

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-WebUserManageSave'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-WebUserManageSave'
            this.snackbar = true
          }
        })

      },
      kullanicisil(val) {


        var input = []

        var kayit = {
          ID: null, //kullanici id
          UserID: val.UserID,
          GroupID: this.WebGrup.GroupID, // group id
          GroupName: null,
          CustomerID: this.AnaSirketKodu, // anaşirket
          CustomerCode: null,
          CustomerName: null,
          CompanyNo: this.altsirket // company
        }

        input.push(kayit)

        var params = input

        this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageUserAuthDelete', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true

          if (response.body.Status == true) {
            var params = {
              ID: null,
              UserID: null,
              CustomerID: this.AnaSirketKodu,
              CompanyNo: this.altsirket,
              GroupID: this.WebGrup.GroupID
            }

            this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageUserCompanyAuthList', params, {
              headers: {
                'Authorization': 'Bearer ' + auth.getAuthHeader()
              }
            }).then((response) => {

              this.itemsyetkili = response.body.AuthUserList
              this.itemsyetkisiz = response.body.NoAuthUserList

            }, (response) => {
              if (response.status === 0) {
                this.text1 = 'Service Unavailable-WebPageUserCompanyAuthList'
                this.snackbar = true
              } else {
                this.text1 = 'Service Unavailable-WebPageUserCompanyAuthList'
                this.snackbar = true
              }
            })
          }
       
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-WebUserManageSave'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-WebUserManageSave'
            this.snackbar = true
          }
        })

      },
      toggleAll() {
        if (this.selectedyetkisiz.length) this.selectedyetkisiz = []
        else this.selectedyetkisiz = this.itemsyetkisiz.slice()
      },

      logout() {
        auth.logout()
      },
      yenikullanicikaydet() {

        var sayfayetkilist = []

        if (this.WebGrup.CustomerID != null && this.WebGrup.GroupName) {

          this.sayfalist.forEach(element => {

            var yetkilist = {
              PageName: element.PageName,
              Screen: this.dinamikmodelekran[element.PageName],
              Update: this.dinamikmodelguncelle[element.PageName],
              Delete: this.dinamikmodelsil[element.PageName],
              Save: this.dinamikmodelkaydet[element.PageName]
            }

            sayfayetkilist.push(yetkilist)
          });


          this.WebGrup.PagesInfo = sayfayetkilist

          var groupparams = this.WebGrup

          this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageGroupSave', groupparams, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true

            if (response.body.Status == true) {

              var url = '#/uye/index'
              setTimeout(function () {
                window.open(url, '_self')
              }.bind(this), 5000)

            }


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-WebUserManageSave'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-WebUserManageSave'
              this.snackbar = true
            }
          })

        } else {
          this.text1 = this.$t('Please-Enter-Complete-Group-Information')
          this.snackbar = true
        }

      },
      sayfayetkiguncelle() {

        var sayfayetkilist = []

        if (this.WebGrup.GroupName != null) {

          this.sayfaguncellelist = this.yedeksayfaguncellelist

          this.sayfaguncellelist.forEach(element => {

            var yetkilist = {
              PageName: element.PageName,
              Screen: this.dinamikmodelekran[element.PageName],
              Update: this.dinamikmodelguncelle[element.PageName],
              Delete: this.dinamikmodelsil[element.PageName],
              Save: this.dinamikmodelkaydet[element.PageName],
              PageGroup: element.PageGroup,
              PageTitle: element.PageTitle
            }

            sayfayetkilist.push(yetkilist)
          });

          this.WebGrup.PagesInfo = sayfayetkilist

          var groupparams = this.WebGrup

          this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageGroupSave', groupparams, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true
            this.manageloadguncelle();

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-WebPageGroupSave'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-WebPageGroupSave'
              this.snackbar = true
            }
          })

        } else {
          this.text1=this.$t('Please-Enter-Complete-Group-Information')
          this.snackbar = true
        }
      },
      listesil(val) {

        for (var i = 0; i < this.itemseklenen.length; i++) {
          if (this.itemseklenen[i].MusteriKod == val.MusteriKod) {
            this.itemseklenen.splice(i, 1);
          }
        }
      },
      listeyeekle() {
        var kayitvarmi = this.itemseklenen.map(function (e) {
          return e.MusteriKod;
        }).indexOf(this.WebUserAnaSirket.MusteriKod);

        if (this.AnaSirket != null && typeof (this.AnaSirket) != 'object') {
          if (kayitvarmi === -1) {
            var yenikayit = {
              MusteriID: this.WebUserAnaSirket.MusteriID,
              MusteriKod: this.WebUserAnaSirket.MusteriKod,
              MusteriUnvan: this.WebUserAnaSirket.MusteriUnvan,
              UserTip: this.WebUserAnaSirket.UserTip,
              Aktif: this.WebUserAnaSirket.Aktif,
              Masraf: this.WebUserAnaSirket.Masraf,
              Referans: this.WebUserAnaSirket.Referans,
              Bolum: this.WebUserAnaSirket.Bolum
            }
            this.itemseklenen.push(yenikayit)
          } else {
            this.text1 = this.$t('Record-not-included-list')
            this.snackbar = true
          }
        } else {
          this.text1 = this.$t('Select-Your-Main-Company')
          this.snackbar = true
        }
      },
      detayagit(val) {
        this.listeleme = false;
        this.detay = true;
        this.UserInfo = val;

        var userparams = {
          Email: val.Email
        }

        this.$http.post(auth.API_URL + 'api/Register/WebUserManageLoad', userparams, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.yetkilist = response.body.AnaSirketInfo

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-WebUserManageLoad'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-WebUserManageLoad'
            this.snackbar = true
          }
        })


      },
      yenisirketac() {
        this.bekle = true;

        var response1 = JSON.parse(window.localStorage.getItem('response'));

        if (this.yenisirketunvani != null && this.yenisirketunvani != '') {
          var params = {
            Mail: response1.Email,
            CustomerInfo: {
              Ad: this.yenisirketunvani
            }
          }

          this.$http.post(auth.API_URL + 'api/Register/NewCustomerAdd', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

             this.text1 = this.$t(response.body.ResponseMessage)
            this.snackbar = true

            if (response.body.Status == true) {
              this.text1 = this.$t('company-has-allocated-free-10-day')
              this.snackbar = true
              this.dialogyenisirket = false;
              this.sirkettipi = '0';
              this.bekle = false;


              var params = {
                Email: response1.Email

              }
              this.$http.post(auth.API_URL + 'api/Register/WebUserList', params, {
                headers: {
                  'Authorization': 'Bearer ' + auth.getAuthHeader()
                }
              }).then((response) => {
                this.bekle = false;


                this.yedekresponse = response1
                window.localStorage.removeItem('response')


                var sirketlers = []

                Object.keys(response.body[0].MusteriBilgi).forEach(key => {
                  var anasirket = {
                    Ad: response.body[0].MusteriBilgi[key].Ad,
                    GenelSirketler: response.body[0].MusteriBilgi[key].Sirketler,
                    MusteriId: response.body[0].MusteriBilgi[key].MusteriID,
                    MusteriKod: response.body[0].MusteriBilgi[key].MusteriKod
                  }

                  sirketlers.push(anasirket)
                });

                var newresponse = {
                  AdSoyad: this.yedekresponse.AdSoyad,
                  Email: this.yedekresponse.Email,
                  MusteriDbler: sirketlers,
                  Token: this.yedekresponse.Token,
                  UserId: this.yedekresponse.UserId
                }

                //yeni response oluşturuldu

                window.localStorage.setItem('response', JSON.stringify(newresponse));

                sirketlers = []
                // yeni response ile tüm kartları güncelleyelim

                var yeniresponse = JSON.parse(window.localStorage.getItem('response'));
                yeniresponse.MusteriDbler.forEach(element => {

                  var sirket = {
                    text: element.Ad,
                    id: element.MusteriKod,
                    baglisirketler: element.GenelSirketler
                  }
                  sirketlers.push(sirket)

                });

                this.AnaSirketler = sirketlers;
                this.AnaSirketlerWiev = [];

                var yedeklist = []

                this.AnaSirketler.forEach(element => {
                  var id = element.id;
                  var text = element.text;
                  var baglisirket = [];
                  baglisirket = element.baglisirketler

                  var params = {
                    MusteriInfo: {
                      MusteriKod: element.id
                    }
                  }

                  this.$http.post(auth.API_URL +
                    'api/Register/ProductCustomerInfo', params, {
                      headers: {
                        'Authorization': 'Bearer ' + auth.getAuthHeader()
                      }
                    }).then((response) => {

                    var sirket = {
                      id: id,
                      text: text,
                      UyelikBitis: response.body.UyelikBitis,
                      UyelikTip: response.body.UyelikTip,
                      KalanKontor: response.body.KalanKontor,
                      UyelikStatus: response.body.UyelikStatus,
                      baglisirketler: baglisirket
                    }


                    yedeklist.push(sirket)

                  }, (response) => {
                    if (response.status === 0) {
                      this.text1 =
                        'Service Unavailable-Company Get'
                      this.bekle = false;

                      this.snackbar = true

                    } else {

                      this.text1 =
                        'Service Unavailable-Company Get'
                      this.snackbar = true

                    }
                  })

                });

                this.AnaSirketlerWiev = yedeklist

              }, (response) => {
                if (response.status === 0) {
                  this.bekle = false;

                  this.text1 = 'Service Unavailable-WebUserList'
                  this.snackbar = true
                } else {
                  this.text1 = 'Service Unavailable-WebUserList'
                  this.snackbar = true
                }
              })
            }


          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-NewCustomerAdd'
              this.bekle = false;

              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-NewCustomerAdd'
              this.bekle = false;

              this.snackbar = true
            }
          })

        } else {
          this.text1 = this.$t('Please-enter-corporate-title')
          this.snackbar = true
          this.bekle = false;

        }
      },
      sirketaciptal() {
        this.dialogyenisirket = false;
        this.sirkettipi = '0';
      },
      urunleredon() {
        this.urunekrani = true;
        this.odemeekrani = false;
      },
      sirketleredon() {
        this.Urunler = false;
        this.giris = true;
      },

      Odeme(urunid, fiyat) {
        this.UrunKayit.UrunInfo.UrunID = urunid
        this.UrunKayit.SatisTutar = fiyat


        this.toplamtutar = fiyat;
        this.odemeekrani = true;
        this.urunekrani = false;
      },
      SatinAl() {
        this.UrunKayit.SatisTarihi = getDateNow()
        this.UrunKayit.MusteriInfo.MusteriKod = this.musteriid
        var params = this.UrunKayit
        this.$http.post(auth.API_URL + 'api/Register/ProductCustomerSave', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
           this.text1 = this.$t(response.body.ResponseMessage)
          this.snackbar = true
          if (response.body.Status == true) {
            this.text1 = this.$t('Payment-successful-you-being-redirected-page')
            this.snackbar = true

            this.guncelle();
            setTimeout(function () {

              this.odemeekrani = false;
              this.urunekrani = true;
              this.giris = true;
              this.Urunler = false;
            }.bind(this), 5000)



          }
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-ProductCustomerSave'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-ProductCustomerSave'
            this.snackbar = true
          }
        })
      },
      urunleregit() {
        this.giris = false
        this.Urunler = true
        var params = {
          ProductID: 0,
          ProductType: 0
        }

        this.$http.post(auth.API_URL + 'api/Register/ProductList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.urunlerlist = response.body
          this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.UrunTip == 2)
              this.productshow.push(element)
          });
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Company Get'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Company Get'
            this.snackbar = true
          }
        })
      },
      guncelle,
      userlist
    },
    beforeMount: beforeMount,
    components: {
      navi,
      referansmerkezicomp,
      masrafmerkezicomp,
      bolumcomp,
      altaciklama,
      yetkidialog
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    mounted() {

      this.AnaSirketKodu = this.$route.query.cid

      var response3 = JSON.parse(window.localStorage.getItem('response'));
      var response2 = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

      this.AnaSirketler = helpers.yetkilisirketlerigetir(response2.AnaSirketInfo)


      response3.MusteriDbler.forEach(element => {
        if (this.$route.query.cid == element.MusteriId) {
          this.altsirketler = element.GenelSirketler
        }

      });



      if (this.$route.query.isl != 'guncelle') {

        this.islemyeni = true
        this.islemguncelle = false

        this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageList', null, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {

          this.sayfalist = response.body

        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-WebPageGroupList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-WebPageGroupList'
            this.snackbar = true
          }
        })



      } else {

        this.islemyeni = false
        this.islemguncelle = true

        var params = {
          GroupID: this.$route.query.gid,
          CustomerID: this.$route.query.cid,
          AuthList: false,
        }
        this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageGroupLoad', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {



          this.WebGrup = response.body

          if (response.body.PagesInfo.length > 0) {

            this.sayfaguncellelist = response.body.PagesInfo
            this.yedeksayfaguncellelist = response.body.PagesInfo

            this.sayfaguncellelist.forEach(element => {
              this.dinamikmodelekran[element.PageName] = Boolean(element.Screen)
              this.dinamikmodelkaydet[element.PageName] = Boolean(element.Save)
              this.dinamikmodelguncelle[element.PageName] = Boolean(element.Update)
              this.dinamikmodelsil[element.PageName] = Boolean(element.Delete)
            });

          }


        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-WebPageGroupLoad'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-WebPageGroupLoad'
            this.snackbar = true
          }
        })

      }

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)
    },
    watch: {
      'uyeliktipi': function (value) {
        if (value == 0) {
          this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.UrunTip == 2)
              this.productshow.push(element)
          });
        } else {
          this.productshow = [];
          this.urunlerlist.forEach(element => {
            if (element.UrunTip == 3)
              this.productshow.push(element)
          });
        }
      },
      'UrunKayit.OdemeOnay': function (value) {
        if (value == 'false') {
          this.havale = true;
          this.kredikarti = false;
        } else {
          this.havale = false;
          this.kredikarti = true;

        }
      },
      'AnaSirket': function (value) {

        if (value != null) {
          this.AnaSirketler.forEach(element => {
            if (element.MusteriKod == value) {
              this.WebGrup.CustomerID = element.MusteriID
            }
          });
        }
      },
      'altsirket': function (value) {

        if (value != null) {

          var params = {
            ID: null,
            UserID: null,
            CustomerID: this.AnaSirketKodu,
            CompanyNo: value,
            GroupID: this.WebGrup.GroupID
          }

          this.$http.post(auth.API_URL + 'api/RegisterAuth/WebPageUserCompanyAuthList', params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {

            this.itemsyetkili = response.body.AuthUserList
            this.itemsyetkisiz = response.body.NoAuthUserList

          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service Unavailable-WebPageUserCompanyAuthList'
              this.snackbar = true
            } else {
              this.text1 = 'Service Unavailable-WebPageUserCompanyAuthList'
              this.snackbar = true
            }
          })
        }
      },

      'sirkettipi': function (value) {
        if (value == '0') {
          this.mevcutsirketmi = true;
          this.yenisirket = false;
          this.dialogyenisirket = false;
        } else {
          this.dialogyenisirket = true;
          this.mevcutsirketmi = false;
          this.yenisirket = true;
        }
      },
      'ekrancheck': function (value) {
        if (value == true) {
          this.sayfaguncellelist.forEach(element => {
            this.dinamikmodelekran[element.PageName] = true
          });


        } else {
          this.sayfaguncellelist.forEach(element => {
            this.dinamikmodelekran[element.PageName] = false
          });
        }
      },
      'kayitcheck': function (value) {
        if (value == true) {

          this.sayfaguncellelist.forEach(element => {
            this.dinamikmodelkaydet[element.PageName] = true
          });
        } else {

          this.sayfaguncellelist.forEach(element => {
            this.dinamikmodelkaydet[element.PageName] = false
          });
        }
      },
      'guncellecheck': function (value) {
        if (value == true) {

          this.sayfaguncellelist.forEach(element => {
            this.dinamikmodelguncelle[element.PageName] = true
          });
        } else {

          this.sayfaguncellelist.forEach(element => {
            this.dinamikmodelguncelle[element.PageName] = false
          });
        }
      },
      'silcheck': function (value) {
        if (value == true) {
          this.sayfaguncellelist.forEach(element => {
            this.dinamikmodelsil[element.PageName] = true
          });
        } else {

          this.sayfaguncellelist.forEach(element => {
            this.dinamikmodelsil[element.PageName] = false
          });
        }
      },
      'yeniekrancheck': function (value) {
        if (value == true) {
          this.sayfalist.forEach(element => {
            this.dinamikmodelekran[element.PageName] = true
          });
        } else {

          this.sayfalist.forEach(element => {
            this.dinamikmodelekran[element.PageName] = false
          });
        }
      },
      'yenikayitcheck': function (value) {
        if (value == true) {

          this.sayfalist.forEach(element => {
            this.dinamikmodelkaydet[element.PageName] = true
          });
        } else {

          this.sayfalist.forEach(element => {
            this.dinamikmodelkaydet[element.PageName] = false
          });
        }
      },
      'yeniguncellecheck': function (value) {
        if (value == true) {

          this.sayfalist.forEach(element => {
            this.dinamikmodelguncelle[element.PageName] = true
          });
        } else {

          this.sayfalist.forEach(element => {
            this.dinamikmodelguncelle[element.PageName] = false
          });
        }
      },
      'yenisilcheck': function (value) {
        if (value == true) {
          this.sayfalist.forEach(element => {
            this.dinamikmodelsil[element.PageName] = true
          });
        } else {
          this.sayfalist.forEach(element => {
            this.dinamikmodelsil[element.PageName] = false
          });
        }
      },
    },
    filters: {
      dateformat: function (t) {
        var date = new Date(t);
        var fulldate = date.toLocaleDateString("tr-TR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        });
        return fulldate;
      },
      moneyformat: function (m) {
        return m.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,')
      }
    },
  }

  function beforeMount() {
  }

  function guncelle() {}
  function userlist() {

    var response = JSON.parse(window.localStorage.getItem('response'));

    var userparams = {
      Email: response.Email
    }

    this.$http.post(auth.API_URL + 'api/Register/WebUserConnList', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      }
    })
  }

  function kullaniciKaydet() {

    var response = JSON.parse(window.localStorage.getItem('response'));
    this.ManageInfo.UserInfo.KullaniciAdi = 'user1'
    this.ManageInfo.UserInfo = '123456'

    var userparams = this.ManageInfo

    this.$http.post(auth.API_URL + 'api/Register/WebUserManageSave', userparams, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-WebUserConnList'
        this.snackbar = true
      }
    })

  }
</script>